var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" },
      ],
      staticClass: "storefinder-map-marker",
    },
    [
      _c(
        "div",
        { ref: "info", staticClass: "infoWindow" },
        [_vm._t("infoWindow")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }